module.exports = __webpack_public_path__ + "img/image_36.643ad674.png";